var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home"},[_c('hk-header'),_c('div',{staticClass:"home-container flex"},[_c('c-side-bar'),_c('router-view')],1),_c('hk-footer',{attrs:{"theme":"dark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }